"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPoeKeyForRFISubtype = void 0;
const Literals = __importStar(require("../constants/rfi.literals"));
const getPoeKeyForRFISubtype = (subType, translate) => {
    const keys = {
        W9_UPDATE: translate(Literals.W9_UPDATE_RFI_SUBTYPE),
        LEGAL_NAME: translate(Literals.LEGAL_NAME_RFI_SUBTYPE),
        OFAC: translate(Literals.OFAC_RFI_SUBTYPE),
        DYNAMIC_QUESTIONS: translate(Literals.DYNAMIC_QUESTIONS_RFI_SUBTYPE),
        COMPLAINTS: translate(Literals.COMPLAINTS_RFI_SUBTYPE),
        ACH_CLAIMS: translate(Literals.ACH_CLAIMS_RFI_SUBTYPE),
        WIRE_EXCEPTION: translate(Literals.WIRE_EXCEPTION_RFI_SUBTYPE),
    };
    return keys[subType] || subType;
};
exports.getPoeKeyForRFISubtype = getPoeKeyForRFISubtype;
//# sourceMappingURL=rfi.utils.js.map